// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"Tab_tabContainer__6_E_c","cTab":"Tab_cTab__1fphn","active":"Tab_active__1oGi6","tabPanel":"Tab_tabPanel__2lt9m"};